var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiagram(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C1.72386 1 1.5 1.22386 1.5 1.5V8.5C1.5 8.77614 1.72386 9 2 9H9C9.27614 9 9.5 8.77614 9.5 8.5V1.5C9.5 1.22386 9.27614 1 9 1H2ZM2 0H9C9.82843 0 10.5 0.671573 10.5 1.5V8.5C10.5 9.32843 9.82843 10 9 10H2C1.17157 10 0.5 9.32843 0.5 8.5V1.5C0.5 0.671573 1.17157 0 2 0Z",
    fill: "#393B4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4.5C3.05964 4.5 2.5 3.94036 2.5 3.25C2.5 2.55964 3.05964 2 3.75 2C4.44036 2 5 2.55964 5 3.25C5 3.94036 4.44036 4.5 3.75 4.5ZM3.75 3.5C3.88807 3.5 4 3.38807 4 3.25C4 3.11193 3.88807 3 3.75 3C3.61193 3 3.5 3.11193 3.5 3.25C3.5 3.38807 3.61193 3.5 3.75 3.5Z",
    fill: "#393B4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35355 9.85355C2.15829 10.0488 1.84171 10.0488 1.64645 9.85355C1.45118 9.65829 1.45118 9.34171 1.64645 9.14645L7.14645 3.64645C7.34171 3.45118 7.65829 3.45118 7.85355 3.64645L10.3536 6.14645C10.5488 6.34171 10.5488 6.65829 10.3536 6.85355C10.1583 7.04882 9.84171 7.04882 9.64645 6.85355L7.5 4.70711L2.35355 9.85355Z",
    fill: "#393B4A"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.8dfb23d496129d9197756d897d35845f.svg";
export { ForwardRef as ReactComponent };